import { z } from "zod";

export type ListStaffInGroupResponse = z.infer<typeof ListStaffInGroupResponseSchema>;
export const ListStaffInGroupResponseSchema = z.object({
  icon: z.string(),
  idAccount: z.number(),
  isBusy: z.boolean(),
  name: z.string(),
});
